import axios from 'axios';

import { store } from '../redux';
import appConfig from '../config';

const client = axios.create({
  baseURL: appConfig.backendBaseUrl,
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  // Only attach auth token when it exists (participant flow uses session cookie).
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default client;
